import {Component, OnInit} from '@angular/core';
import {StartupService} from '../../../services/startup/startup.service';
import {Router} from '@angular/router';
import {ENVIRONMENT} from '../../../../environments/environment';

@Component({
    selector: 'tig-app-error',
    templateUrl: './errorlogin.component.html',
})
export class ErrorloginComponent implements OnInit {

    STR_reason: string;

    /**
     * Function > constructor
     */
    constructor
    (
        private OBJ_startup_service: StartupService,
        private OBJ_router: Router
    ) {} // end function constructor


    /**
     * Function > ngOnInit
     */
    ngOnInit()
    {
        
        if (localStorage.getItem('error_reason')) {
            this.STR_reason = localStorage.getItem('error_reason');
            localStorage.removeItem('error_reason');
        } // end if

    } // end function ngOnInit


    /**
     * Function > retry
     */
    retry()
    {
        
        // TODO: maybe show loading gif --> but for this we need Observable, not promise, i think
        this.OBJ_startup_service.load(ENVIRONMENT.config_path)
            .then(value => {
                this.OBJ_router.navigate(['\login']);
            });

    } // end function retry

} // end class ErrorloginComponent